
import { partyJsonDataType } from '@/types/Information/json';
import { Component, Vue, Prop } from 'vue-property-decorator';

import AddPartyModal from './AddPartyModal.vue'

@Component({
    components:{        
        AddPartyModal        
    }
})
export default class PartiesTable extends Vue { 
    
    @Prop({required:true})
    formInfo: any 

    @Prop({required:true})
    state: any
     
    partyFields = [
        { key:'organization', label:'Party Type', thClass: 'text-white bg-court', thStyle: '', sortable:false }, 
        { key:'name', label:'Party Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },        
        { key:'edit', label:'', thClass: 'text-white bg-court', sortable:false }        
    ]


    AddNewRespondentForm = false;
    AddNewAppellantForm = false;
    AddNewIntervenerForm = false;
    
    partyToEdit = {} as partyJsonDataType;
    isCreate = true
    partyType = ''
    showPartyWindow = false

    updated=0;

    public addNewParty(type){
        this.partyToEdit = {} as partyJsonDataType
        this.partyType = type
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editParty(data, type) {
        this.partyToEdit = data.item
        this.partyType = type;
        this.isCreate = false;
        this.showPartyWindow = true;
    }

    public removeParty(data, type){ 
        const formData = this.formInfo;       
        formData[type].splice(data.index,1);
        this.updated ++;        
    }


    public partyChanged(partyCreated){
        if(partyCreated){
            const formInfo = this.formInfo
            const party = JSON.parse(JSON.stringify(this.partyToEdit))
            if(this.partyType == 'Appellant'){
                formInfo.appellants.push(party);
            }
            else if(this.partyType =='Respondent'){
                formInfo.respondents.push(party);
            }
            else if(this.partyType =='Intervener'){
                formInfo.interveners.push(party);
            }
        }        
        this.showPartyWindow = false;        
        this.$emit('partyChanged')

    }
}
